import api from '../api';
import { plataformaAtual } from '../utils/push';

const montarInscricao = (subscription = {}) => ({
  endpoint: subscription.endpoint,
  keys: subscription.keys,
  expirationTime: subscription.expirationTime || null,
  plataforma: plataformaAtual(),
});

export const pushService = {
  async vapidPublicKey() {
    const { data } = await api.get('/push/vapid-public-key');
    return data;
  },

  async status() {
    const { data } = await api.get('/push/status');
    return data;
  },

  async inscrever(subscription) {
    const { data } = await api.post('/push/inscricoes', montarInscricao(subscription));
    return data;
  },

  async remover(endpoint) {
    const { data } = await api.delete('/push/inscricoes', { data: { endpoint } });
    return data;
  },

  async removerTodas() {
    const { data } = await api.delete('/push/inscricoes/todas');
    return data;
  },

  async testar() {
    const { data } = await api.post('/push/teste');
    return data;
  },
};

export default pushService;
